import React from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Typography } from 'seagull';
import { routes } from "../../constants";
import { ProposalsIllustration } from "../../pages/ProposalsDashboard/ProposalsIllustration";
import styles from "./CanceledProposalPage.module.scss";
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { UserRole } from "../../models/UserInfoModel";
export default function CanceledProposalPage() {
  const role = useStore(selectors.user.role);
  const showGoBackButton = role !== UserRole.Reviewer;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": "canceled-proposal-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(ProposalsIllustration, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    weight: "normal",
    className: styles.text
  }, "Canceled proposal"), /*#__PURE__*/React.createElement(Typography, {
    className: styles.text
  }, "Your vendor has canceled this proposal, and the link has changed. As soon as the vendor sends you a new proposal, you will receive an updated link."), showGoBackButton && /*#__PURE__*/React.createElement(NavLink, {
    to: routes.proposalsDashboard
  }, /*#__PURE__*/React.createElement(Button, {
    skin: "primary",
    className: styles.button,
    "data-testid": "canceled-proposal-go-back"
  }, "Go back to Anchor"))));
}